import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { GlobalDataProvider } from "hooks/globalData";
import { queryClient } from "index";
import en from "intl/en";
import React from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { QueryClientProvider } from "react-query";
import { KnowfullyLocalizationProvider } from "@knowfully/ui.common";
import { CustomThemeProvider } from "./CustomThemeProvider";
import contextStore from "stores/contextStore";

type AppDependenciesProviderProps = {
  children: React.ReactNode;
};

export const AppDependenciesProvider = ({
  children,
}: AppDependenciesProviderProps) => {
  const { organization } = contextStore.useState();

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <QueryClientProvider client={queryClient}>
        <KnowfullyLocalizationProvider
          locale="en"
          organizationId={organization?.id}
          defaultMessages={en}
        >
          <GlobalDataProvider>
            <DndProvider backend={HTML5Backend}>
              <CustomThemeProvider>{children}</CustomThemeProvider>
            </DndProvider>
          </GlobalDataProvider>
        </KnowfullyLocalizationProvider>
      </QueryClientProvider>
    </LocalizationProvider>
  );
};
